var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import * as React from 'react';
import { iconLight } from '../Styles/Colours';
import styles from './AutosaveIndicator.module.css';
import { CloudDoneIcon, CloudErrorIcon } from './Icons';
export var AutosaveStates;
(function (AutosaveStates) {
    AutosaveStates["initial"] = "initial";
    AutosaveStates["saving"] = "saving";
    AutosaveStates["saved"] = "saved";
    AutosaveStates["failed"] = "failed";
})(AutosaveStates || (AutosaveStates = {}));
export var AutosaveIndicator = function (props) {
    var _a, _b, _c, _d;
    var _e = __read(useState(props.saveState === AutosaveStates.saved ? new Date() : null), 2), saveTime = _e[0], setSaveTime = _e[1];
    var _f = __read(useState(0), 2), saveTimeInMinutes = _f[0], setSaveTimeInMinutes = _f[1];
    var updateSaveTime = function () {
        if (props.saveState === AutosaveStates.saved) {
            setSaveTimeInMinutes(!!saveTime ? moment().diff(saveTime, 'minutes') : 0);
        }
        else {
            setSaveTimeInMinutes(0);
        }
    };
    useEffect(function () {
        var timeOut;
        if (props.saveState === AutosaveStates.saved) {
            setSaveTime(new Date());
            updateSaveTime();
            timeOut = setInterval(function () {
                updateSaveTime();
            }, 3000);
        }
        else {
            setSaveTime(null);
        }
        return function () {
            if (timeOut)
                clearInterval(timeOut);
        };
    }, [props.saveState]);
    var retryClick = function (event) {
        event.stopPropagation();
        if (props.retryFunction)
            props.retryFunction();
    };
    var autosave = classNames(styles.autosave, (_a = {},
        _a[styles.saving] = props.saveState === AutosaveStates.saving,
        _a));
    var autosaveText = classNames(styles.autosaveText, (_b = {},
        _b[styles.saving] = props.saveState === AutosaveStates.saving,
        _b[styles.saveFailed] = props.saveState === AutosaveStates.failed,
        _b));
    var autosaveSpinner = classNames(styles.autosaveSpinner, (_c = {},
        _c[styles.saving] = props.saveState === AutosaveStates.saving,
        _c[styles.saveFailed] = props.saveState === AutosaveStates.failed,
        _c));
    var autosaveError = classNames(styles.autosaveError, (_d = {},
        _d[styles.saveFailed] = props.saveState === AutosaveStates.failed,
        _d));
    return (React.createElement("div", { className: autosave },
        React.createElement("span", { className: autosaveText, style: { color: props.textColor } },
            React.createElement(CloudDoneIcon, { noPadding: true, size: '16', color: iconLight }),
            React.createElement("span", { className: styles.spinnerText }, props.saveState === AutosaveStates.saved && saveTimeInMinutes > 0
                ? "Last edited " + saveTimeInMinutes + " minute" + (saveTimeInMinutes > 1 ? 's' : '') + " ago"
                : 'Changes saved')),
        React.createElement("span", { className: autosaveSpinner },
            React.createElement(CircularProgress, { size: 16 }),
            React.createElement("span", { className: styles.spinnerText, style: { color: props.textColor } },
                "Saving...",
                ' ')),
        React.createElement("span", { className: autosaveError },
            React.createElement(CloudErrorIcon, { size: '16', color: iconLight }),
            React.createElement("span", { className: styles.spinnerText }, "Error Saving."),
            React.createElement("span", { className: styles.retryText, onClick: retryClick }, "Retry"))));
};
